export default "__VITE_ASSET__BjbM2IOh__"